import { IColumn } from "@fluentui/react";
import strings from "../../loc/strings";

export enum NaturalColumnFieldName {
  FirstName = "FirstName",
  LastName = "LastName",
  AlsoKnownAs = "AlsoKnownAs",
  DateOfBirth = "DateOfBirth",
  PlaceOfBirth = "placeOfBirth",
  IdNumber = "ID",
  SocialSecurityNumber = "SocialSecurityNumber",
  RelevanceScore = "RelevanceScore",
  Actions = "Actions",
}

export enum LegalColumnFieldName {
  LegalName = "LegalName",
  AlsoKnownAs = "AlsoKnownAs",
  LeiRegistration = "LeiRegistration",
  CountryInc = "CountryInc",
  RelevanceScore = "RelevanceScore",
  Actions = "Actions",
}

export const _naturalColumns: IColumn[] = [
  {
    key: "column0",
    name: strings.firstNameLabel,
    fieldName: NaturalColumnFieldName.FirstName,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "column1",
    name: strings.lastNameLabel,
    fieldName: NaturalColumnFieldName.LastName,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "column2",
    name: strings.alsoKnownAsLabel,
    fieldName: NaturalColumnFieldName.AlsoKnownAs,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "column3",
    name: strings.dateOfBirthLabel,
    fieldName: NaturalColumnFieldName.DateOfBirth,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "column4",
    name: strings.placeOfBirthLabel,
    fieldName: NaturalColumnFieldName.PlaceOfBirth,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "column5",
    name: strings.idNumberLabel,
    fieldName: NaturalColumnFieldName.IdNumber,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "column6",
    name: strings.socialSecurityNumberLabel,
    fieldName: NaturalColumnFieldName.SocialSecurityNumber,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "column7",
    name: strings.relevanceScoreLabel,
    fieldName: NaturalColumnFieldName.RelevanceScore,
    minWidth: 100,
    isResizable: true,
    isSorted: true,
    isSortedDescending: true
  },
  {
    key: "column8",
    name: strings.actionsLabel,
    fieldName: NaturalColumnFieldName.Actions,
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
];

export const _legalColumns: IColumn[] = [
    {
      key: "column0",
      name: strings.legalNameLabel,
      fieldName: LegalColumnFieldName.LegalName,
      minWidth: 100,
      maxWidth: 380,
      isResizable: true,
    },
    {
      key: "column1",
      name: strings.alsoKnownAsLabel,
      fieldName: LegalColumnFieldName.AlsoKnownAs,
      minWidth: 100,
      maxWidth: 270,
      isResizable: true,
    },
    {
      key: "column2",
      name: strings.leiRegistrationNumberLabel,
      fieldName: LegalColumnFieldName.LeiRegistration,
      minWidth: 100,
      maxWidth: 270,
      isResizable: true,
    },
    {
      key: "column3",
      name: strings.countryOfIncorporationLabel,
      fieldName: LegalColumnFieldName.CountryInc,
      minWidth: 100,
      maxWidth: 270,
      isResizable: true,
    },
    {
      key: "column4",
      name: strings.relevanceScoreLabel,
      fieldName: LegalColumnFieldName.RelevanceScore,
      minWidth: 170,
      isResizable: true,
      isSorted: true,
      isSortedDescending: true
    },
    {
      key: "column5",
      name: strings.actionsLabel,
      fieldName: LegalColumnFieldName.Actions,
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      isMultiline: true,
    },
  ];
